import { render, staticRenderFns } from "./orders-status-changer.vue?vue&type=template&id=2a583c7c"
import script from "./orders-status-changer.vue?vue&type=script&lang=js"
export * from "./orders-status-changer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports